import React from 'react';
import { motion } from 'framer-motion';
interface NavbarProps {
  onOpenModal: () => void;
}
export function Navbar({
  onOpenModal
}: NavbarProps) {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className="fixed top-0 left-0 right-0 z-40 glass-nav" data-id="element-254">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-255">
        <div className="flex items-center" data-id="element-256">
          <img src="https://cdn.magicpatterns.com/uploads/qEEy43avvCWF5rLKaa36MD/ChatGPT_Image_Jul_9,_2026,_05_23_53_PM.png" alt="Stopply" className="w-36 md:w-44 h-auto object-contain object-left" data-id="element-257" />
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-textSecondary" data-id="element-258">
          <a href="#how-it-works" className="hover:text-white transition-colors" data-id="element-259">
            How It Works
          </a>
          <a href="#solutions" className="hover:text-white transition-colors" data-id="element-260">
            Solutions
          </a>
          <a href="#integrations" className="hover:text-white transition-colors" data-id="element-261">
            Integrations
          </a>
          <a href="#why-stopply" className="hover:text-white transition-colors" data-id="element-262">
            Why Stopply
          </a>
          <a href="#pricing" className="hover:text-white transition-colors" data-id="element-263">
            Pricing
          </a>
        </div>

        <div className="flex items-center gap-4" data-id="element-264">
          <button className="hidden md:block text-sm font-medium text-textSecondary hover:text-white transition-colors" data-id="element-265">
            Contact
          </button>
          <button onClick={onOpenModal} className="bg-white text-black text-sm font-medium px-5 py-2.5 rounded-full hover:bg-white/90 transition-colors" data-id="element-266">
            Build My Dashboard
          </button>
        </div>
      </div>
    </motion.nav>;
}